import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App, { preloadRoute } from "@/App";
import { installChunkErrorHandlers } from "@/lib/chunkReload";

installChunkErrorHandlers();

const start = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

// Nejdřív kód aktuální stránky, pak React. HTML z prerenderu je mezitím vidět;
// bez toho by ho React hned nahradil spinnerem (viz lib/lazyWithPreload.js).
// Když se stažení nepovede, startujeme i tak – React.lazy to zkusí znovu.
preloadRoute(window.location.pathname).catch(() => {}).then(start);
